import type { ApplicationStatusResponse } from "@credit-acceptance/step6-bff-client";

import { descriptionsForCodes } from "./dealStatusCatalog";

// Deal is "pre-approval" when the CAS status/phase pair signals the app is
// still ahead of a full approval decision (OR-23394 follow-up). Sourced from
// dealStatusCatalog's AP/PD alias lists (not a local literal set) so a
// statusDescription of "Approval" — the alternate AP spelling documented
// there — is recognized here too, not just "Approval Pending".
const PRE_APPROVAL_STATUSES = descriptionsForCodes("AP", "PD");
export const PRE_APPROVAL_PHASES = new Set(["Pre-approval Requested", "Pre-approval Pending"]);

/**
 * Pure predicate for whether a deal is a pre-approval app: `statusDescription`
 * is one of AP's/PD's known aliases ("Approval"/"Approval Pending"/"Pending
 * Deal") AND `phaseDescription` is one of "Pre-approval Requested"/
 * "Pre-approval Pending".
 * @param {ApplicationStatusResponse | undefined} status - The BFF application status response.
 * @returns {boolean} True when the deal is a pre-approval app.
 */
export function isPreApprovalApp(status: ApplicationStatusResponse | undefined): boolean {
  const statusDescription = status?.statusDescription?.trim();
  const phaseDescription = status?.phaseDescription?.trim();

  if (!statusDescription || !phaseDescription) {
    return false;
  }

  return PRE_APPROVAL_STATUSES.has(statusDescription) && PRE_APPROVAL_PHASES.has(phaseDescription);
}
